import { render, staticRenderFns } from "./Quejas.vue?vue&type=template&id=64482cd6&scoped=true"
import script from "./Quejas.vue?vue&type=script&lang=js"
export * from "./Quejas.vue?vue&type=script&lang=js"
import style0 from "./Quejas.vue?vue&type=style&index=0&id=64482cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64482cd6",
  null
  
)

export default component.exports